import React, { useState, useEffect } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { addOption, removeOption, normalizeGroupedOptions } from '../helpers';
import { useFilterCount } from '../hooks';

export const GroupsSelectPopover = ({ availableGroupsOptions, onCountChange = undefined }) => {
  const { control, setValue, getValues } = useFormContext();
  const { t } = useTranslation();
  const [allOptions, setAllOptions] = useState(availableGroupsOptions);
  const [createdOptions, setCreatedOptions] = useState([]);
  const selectedGroups = useWatch({ name: 'group_name' });
  let selectedArray = [];

  if (Array.isArray(selectedGroups)) {
    selectedArray = selectedGroups;
  } else if (selectedGroups) {
    selectedArray = [selectedGroups];
  }

  const filterCount = selectedArray.length > 0 ? 1 : 0;
  useFilterCount('group_name', filterCount, onCountChange);

  useEffect(() => {
    // при инициализации смотрим есть ли в форме уже добавленные опции
    const initialCreated = selectedArray.filter(
      (option) => !availableGroupsOptions.some((c) => c.value === option.value),
    );
    setCreatedOptions(normalizeGroupedOptions(initialCreated));
  }, []);

  useEffect(() => {
    const grouped = normalizeGroupedOptions(availableGroupsOptions);
    setAllOptions([...createdOptions, ...grouped]);
  }, [createdOptions, availableGroupsOptions]);

  const onCreateOption = (option) => {
    setCreatedOptions((prev) => addOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
    setValue('group_name', option);
  };

  const onDeleteOption = (option) => {
    setCreatedOptions((prev) => removeOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
    const current = getValues('group_name');
    if (current?.value === option.value) {
      setValue('group_name', null);
    }
  };

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="groupNameFilter"
      triggerValue={t('videoAnalytics:table_header.group')}
    >
      <CheckboxCustomFilter
        control={control}
        createdOptions={createdOptions}
        isCreatable
        isSearchable
        name="group_name"
        onCreateOption={onCreateOption}
        onDeleteOption={onDeleteOption}
        options={allOptions}
      />
    </CustomFilterPopover>
  );
};
